<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        fullUrl()
        {
            return `${process.env.API_URL}${this.url}/table`
        }
    },

    methods:
    {
        newPost()
        {
            this.$router.push('/posts/create')
        },

        editPost(post)
        {
            this.$router.push(`/posts/edit/${post.id}`)
        },
    },

    data()
    {
        return {
            noFetch: true,
            data: [],
            url: '/v1/admin/posts',
            tableName: 'tablePosts',
            emptyModel: { name: null, type: 'info', attachments: [], order: 1 },
            columns: [ 'id', 'slug', 'category', 'title', 'updated_at', 'actions', ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    slug: this.$t('POST.SLUG'),
                    category: this.$t('POST.CATEGORY'),
                    title: this.$t('POST.TITLE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
                sortable: ['id', 'updated_at', 'title', 'slug'],
                responseAdapter: res => {
                    return res && res.data ? {
                      data: res.data.data,
                      count: res.data.count,
                    } : { data: [], count: 0}
                },
                params: {
                  type: 'info',
                },
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.POSTS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newPost">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-server-table :url="fullUrl" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="editPost(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="category" slot-scope="props">
                        <div v-if="props.row.post_category_id && props.row.post_category">
                            <span class="label label-success">
                                {{ props.row.post_category.name }}
                            </span>
                        </div>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <strong>
                                    {{ $t('POST.CONTENT')}}
                                </strong>
                            </div>
                            <div class="panel-body">
                                <div v-html="props.row.content">
                                </div>
                            </div>
                        </div>
                    </div>
                </v-server-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Posts.vue